import { useFiltering } from "../FilteringProvider";

export default function useFilters() {
    const {
        _brands,
        bimClasses,
        brands,
        countries,
        limit,
        set,
        token,
    } = useFiltering();

    return [
        {
            _brands,
            brands,
            countries,
            bimClasses,
            token,
        },
        set,
        limit,
    ] as const;
}
